<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <router-view /> -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  height: 100%;
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
/* 去除点击公式时的外边框 */
.MathJax {
  outline: 0;
}
.MathJax span {
  vertical-align: initial;
}
.MathJax * {
  line-height: normal !important;
}
[math-model="bbk"] *{
	line-height: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue